import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'members',
    canActivate: [AuthGuard],
    loadChildren: () => import('./appointments/appointments.module').then( m => m.AppointmentsPageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'members/appointment-map',
    loadChildren: () => import('./appointment-map/appointment-map.module').then( m => m.AppointmentMapPageModule)
  },
  {
    path: 'members/appointment-menu',
    loadChildren: () => import('./appointment-menu/appointment-menu.module').then( m => m.AppointmentMenuPageModule)
  },
  {
    path: 'members/appointment-vehicle',
    loadChildren: () => import('./appointment-vehicle/appointment-vehicle.module').then( m => m.AppointmentVehiclePageModule)
  },
  {
    path: 'members/appointment-signature',
    loadChildren: () => import('./appointment-signature/appointment-signature.module').then( m => m.AppointmentSignaturePageModule)
  },
  {
    path: 'members/modal-delete-vehicle',
    loadChildren: () => import('./modalDeleteVehicle/modalDeleteVehicle.module').then( m => m.ModalDeleteVehiclePageModule)
  }
   
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
